AngularService = App.loadClass 'core::Angular/Service'

class exports.Service extends AngularService

    constructor: (@http) ->
        undefined

    save: (year, toAdd, toDelete) =>
        return @http.post 'backend/portal/key-fields-define/save-key-fields',
            year: year
            toAdd: toAdd
            toDelete: toDelete

    fetchFields: (filters) =>
        return @http.get 'backend/portal/key-fields-define/fetch-fields',
            params: {
                filters
            }
